import { ReactNode, useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectUserData } from "../../features/userSlice";
interface AuthGuardProps {
  children: ReactNode;
}

export const AuthGuard = ({ children }: AuthGuardProps) => {
  const userData = useSelector(selectUserData);
  const location = useLocation();

  const isAuthenticated = !!userData?.data;

  useEffect(() => {
    // If not authenticated, save the full URL (including search params) for redirect after login
    if (!isAuthenticated && location.pathname !== "/login") {
      const fullUrl = `${location.pathname}${location.search}`;
      sessionStorage.setItem("redirectUrl", fullUrl);
    }
  }, [isAuthenticated, location]);

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
